import { useTranslation } from "react-i18next";
import {
  CloseOutlined,
  CopyOutlined,
  FileTextOutlined,
  HeatMapOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  PicCenterOutlined,
  PlayCircleOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  SolutionOutlined
} from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  InputNumber,
  message,
  Radio,
  RadioChangeEvent,
  Row,
  Space,
  Typography
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { editReviewCourse, getDetailQuiz, getQuestionBank, } from "../../../service/course-construct";
import FormItemDropdown from "../../form-dropdown/FormItemDropdown";
import FormInput from "../../form-input/FormInput";
import CommonModal from "../../modal/common";

type Props = {
  open: boolean;
  onClose: () => void;
  setLoading?: (value: boolean) => void;
  id?: string;
  parentName?: string;
  handleDetail?: any;
  itemDetail?: any;
};

export default function EditExerciseDrawer(props: Props) {
  const { t } = useTranslation();
  const { handleDetail, onClose } = props;
  const [form] = Form.useForm();
  const [value, setValue] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
  const [listQuestionBank, setListQuestionBank] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [dataSearch, setDataSearch] = useState<any>({
    page: 1,
    size: 20,
    keyword: '',
    types: ["unit_quiz"],
    status: [
      true
    ]
  })
  const [detailData, setDetailData] = useState({
    name: "",
    description: "",
    iconType: 0,
    reviewType: 0,
    formOfReview: 0,
    expectedTime: 0,
    expectedTimeType: 0,
  });

  const getDetailDataQuizEdit = async (id: number) => {
    try {
      const response = await getDetailQuiz(id);
      const { data, status } = response;
      if (status === 200) {
        setDetailData(data);
        setLoading(false)
      }
    } catch (err) {
      console.error(err);
    }
  };


  const validation = {
    title: {
      required: true,
      message: t("Vui lòng nhập tiêu đề.", "Vui lòng nhập tiêu đề."),
    },
  };

  const onChange = (e: RadioChangeEvent) => {
    const type = e.target.value;
    setValue(type);
    let iconType = 1;
    if (type === 1) iconType = 1;
    else if (type === 2) iconType = 2;
    else if (type === 3) iconType = 3;

    form.setFieldsValue({ icon: iconType });
  };


  const OPTIONS = [
    {
      value: 1,
      label: <PlayCircleOutlined />,
    },
    {
      value: 2,
      label: <PicCenterOutlined />,
    },
    {
      value: 3,
      label: <CopyOutlined />,
    },
    {
      value: 4,
      label: <HeatMapOutlined />,
    },
  ];

  const optionTime = [
    {
      id: 10,
      name: t("Phút", "Phút"),
    },
    {
      id: 20,
      name: t("Giờ", "Giờ"),
    },
  ];

  // 1 = 10
  // 2 = 20
  // 1 + 2 = 9999
  const listAssessments = [
    {
      label: t("Trực tuyến", "Trực tuyến"),
      value: 1,
      description: `Người học tham gia đánh giá trên nền tảng ${process.env.REACT_APP_PROJECT_NAME || ""}`,
    },
    {
      label: t("Trực tiếp", "Trực tiếp"),
      value: 2,
      description: t("Người học tham gia đánh giá trực tiếp tại Cơ sở đào tạo", "Người học tham gia đánh giá trực tiếp tại Cơ sở đào tạo"),
    },
  ];

  // Get list evaluation form
  const listVideo = listQuestionBank.map((item: any) => ({
    id: item.id,
    name: item.code,
  }));

  const getEvaluationForm = async (data: any) => {
    try {
      await getQuestionBank(data).then((res) => {
        if (res.status === 200 && res.data.data) {
          setListQuestionBank(res.data.data.content);
          setTotalPages(res.data.data.totalPages);
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  // Load more videoTemplate
  const handlePopupScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // Check scroll to end to increase page
    if (scrollTop + clientHeight >= scrollHeight && !loadingMore) {
      setLoadingMore(true);

      if (totalPages > dataSearch.page) {
        setDataSearch((prevState: any) => ({
          ...prevState,
          page: prevState.page + 1,
        }));

        getQuestionBank({
          ...dataSearch,
          page: dataSearch.page + 1,
        }).then((res: any) => {
          if (res.status === 200 && res.data.data && res.data.data.content.length > 0) {
            // Add new data
            setListQuestionBank((prevList: any) => [
              ...prevList,
              ...res.data.data.content
            ]);
          }

          setLoadingMore(false);
        });
      }
    }
  };

  const gotoAddLessonPage = () => {
    form.submit();
  };

  const renderAssessmentsRadioGroup = (option: any) => {
    return (
      <Radio.Group>
        <Row>
          {option.map((op: any) => (
            <Col span={12} key={op.value} style={{ marginBottom: "16px" }}>
              <Radio value={op.value}>{op.label}</Radio>
              <div
                style={{
                  marginLeft: "24px",
                  paddingRight: "10px",
                  color: "#888",
                  fontSize: "12px",
                }}
              >
                {op.description}
              </div>
            </Col>
          ))}
        </Row>
      </Radio.Group>
    );
  };

  const onFinish = async (name: string, { values, forms }: any) => {
    if (props.id && name === "form-edit-review-course") {
      try {
        const dataEdit = {
          unitId: props.id,
          title: values.title,
          description: values.description,
          iconType: values.icon,
          reviewType: values.typeStatus,
          formOfReview: values.assessments,
          expectedTime: values.expectedTime,
          fromUnitBankCode: values.videoTemplate,
          expectedTimeType: values.expectedTimeType,
        };
        const response = await editReviewCourse(dataEdit);
        const { status } = response;
        if (status === 200) {
          message.success(t("Chỉnh sửa học liệu thành công", "Chỉnh sửa học liệu thành công"));
          setOpenConfirmModal(false);
          getDetailDataQuizEdit(Number(props.id));
          handleDetail();
          form.resetFields();
          onClose();
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    if (props.open) {
      setLoading(true)
      getDetailDataQuizEdit(Number(props.id));
      getEvaluationForm(dataSearch);
    } else {
      setDataSearch({
        page: 1,
        size: 20,
        keyword: '',
        types: ["unit_quiz"],
        status: [
          true
        ]
      });
      setLoadingMore(false);
    }
  }, [props.open])

  useEffect(() => {
    if (detailData && Object.keys(detailData).length > 0) {
      form.setFieldsValue({
        title: detailData.name,
        description: detailData.description,
        icon: detailData.iconType,
        typeStatus: detailData.reviewType,
        assessments: detailData.formOfReview,
        expectedTime: detailData.expectedTime,
        expectedTimeType: detailData.expectedTimeType,
      });
      setValue(detailData.iconType)
    }
  }, [detailData]);

  const renderIcon = () => {
    switch (value) {
      case 1:
        return <FileTextOutlined style={{ fontSize: '24px' }} />
      case 2:
        return <QuestionCircleOutlined style={{ fontSize: '24px' }} />
      case 3:
        return <SolutionOutlined style={{ fontSize: '24px' }} />
    }
  }

  return (
    <Form.Provider onFormFinish={onFinish}>
      <Drawer
        title={t("Chỉnh sửa học liệu", "Chỉnh sửa học liệu")}
        placement={"right"}
        className="add-lession-drawer"
        size={'large'}
        onClose={props.onClose}
        open={props.open}
      >
        <>
          {loading ?
            (
              <div className="loading-content">
                <LoadingOutlined />
              </div>
            )
            :
            (
              <Form
                layout={"vertical"}
                form={form}
                name="form-edit-review-course"
                initialValues={{
                  ["trangThai"]: true,
                }}
              >
                <Row gutter={[24, 12]}>
                  <Typography.Title level={5}>{t("Thông tin chung", "Thông tin chung")}</Typography.Title>

                  <Col span={24}>
                    <Form.Item
                      name="title"
                      rules={[validation.title]}
                      label={t("Tiêu đề", "Tiêu đề")}
                    >
                      <FormInput placeholder={t("Tiêu đề", "Tiêu đề")} />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item name="description" label={t("Mô tả", "Mô tả")}>
                      <TextArea showCount maxLength={512} placeholder={t("Mô tả", "Mô tả")} />
                    </Form.Item>
                  </Col>

                  {/* <Col span={8}>
                    <Form.Item name="icon" label="Icon">
                      <Select
                        placeholder={t("Chọn icon", "Chọn icon")}
                        value={selectedItems}
                        onChange={setSelectedItems}
                        style={{ width: "100%" }}
                        options={OPTIONS.map((item, index) => ({
                          ...item,
                          label: <div>{item.label}</div>,
                        }))}
                      />
                    </Form.Item>
                  </Col> */}
                  <Col span={8}>
                    <Form.Item name="icon" >
                      <div className="flex align-center gap-8">
                        <span>Icon</span>
                        {renderIcon()}
                      </div>
                    </Form.Item>
                  </Col>

                  <Col span={18}>
                    <Form.Item
                      name="videoTemplate"
                      label={t("Chọn mẫu", "Chọn mẫu")}
                      className="last-form-item"
                    >
                      <FormItemDropdown
                        options={listVideo}
                        allowClear={true}
                        placeholder={t("Chọn mẫu", "Chọn mẫu")}
                        onPopupScroll={handlePopupScroll}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item name="typeStatus" label={t("Loại đánh giá", "Loại đánh giá")}>
                      <Radio.Group onChange={onChange} value={value}>
                        <Radio value={1}>{t("Bài tập", "Bài tập")}</Radio>
                        <Radio value={2}>{t("Bài kiểm tra", "Bài kiểm tra")}</Radio>
                        <Radio value={3}>{t("Bài thi", "Bài thi")}</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item name="assessments" label={t("Hình thức đánh giá", "Hình thức đánh giá")}>
                      {renderAssessmentsRadioGroup(listAssessments)}
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item name="expectedTime" label={t("Nỗ lực mong chờ", "Nỗ lực mong chờ")}>
                      <InputNumber style={{ width: "100%" }} min={1} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="expectedTimeType" label=" ">
                      <FormItemDropdown options={optionTime} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="mt-3 float-right">
                  <Space>
                    <Button onClick={props.onClose} className="btn btn-outlined">
                      <CloseOutlined />
                      <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
                    </Button>
                    <Button
                      className="btn btn-primary"
                      onClick={() => setOpenConfirmModal(true)}
                    >
                      <SaveOutlined />
                      <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
                    </Button>
                  </Space>
                </Row>

                <CommonModal
                  open={openConfirmModal}
                  title={t("Thông báo xác nhận lưu", "Thông báo xác nhận lưu")}
                  desc={t("Vui lòng xác nhận lưu học liệu trong khoá học", "Vui lòng xác nhận lưu học liệu trong khoá học")}
                  closeIcon={true}
                  okText={t("Xác nhận", "Xác nhận")}
                  cancelText={t("Huỷ", "Huỷ")}
                  icon={
                    <InfoCircleOutlined
                      style={{ color: "#FFC53D", marginRight: "10px" }}
                    />
                  }
                  confirm={gotoAddLessonPage}
                  closeModal={() => setOpenConfirmModal(false)}
                />
              </Form>
            )
          }

        </>
      </Drawer>
    </Form.Provider>
  );
}
